"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ValidateNumber = exports.ValidateNotEmpty = exports.ValidateLength = exports.ValidateInteger = exports.ValidateBool = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./TRCInput.css");

require("../TRCButton/TRCButton.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
 * @deprecated since 10/29/2020
 * Will be removed soon
 */
var TRCInput = /*#__PURE__*/function (_Component) {
  _inherits(TRCInput, _Component);

  var _super = _createSuper(TRCInput);

  function TRCInput(props) {
    var _this;

    _classCallCheck(this, TRCInput);

    _this = _super.call(this, props);
    console.warn("TRCInput is a depricated component!");
    _this.state = {
      value: _this.props.value ? _this.props.value : '',
      isValid: true,
      isValidMessage: ''
    };
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TRCInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value && this.state.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var val = e.currentTarget.value;
      var error = this.validate(val);
      this.setState({
        value: val,
        isValid: !error,
        isValidMessage: error
      });

      if (this.props.onChange) {
        this.props.onChange(val, error, e);
      }
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var error = null;

      if (this.props.validate) {
        error = this.props.validate(value);
      }

      return error;
    }
  }, {
    key: "render",
    value: function render() {
      var child = null;

      if (this.props.type === 'select') {
        child = this.renderSelect();
      } else if (this.props.type === 'checkbox') {
        child = this.renderCheckbox();
      } else {
        child = this.renderInput();
      }

      var containerClass = "TRCInput ".concat(this.props.className ? this.props.className : '');

      if (!this.state.isValid) {
        containerClass += ' invalid';
      }

      if (this.props.full) {
        containerClass += ' full';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClass
      }, child, !this.state.isValid && /*#__PURE__*/_react.default.createElement("span", {
        className: "error"
      }, this.state.isValidMessage));
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var val = '';
      var extra = {
        className: 'trc-input'
      };

      if (this.props.id) {
        extra['id'] = this.props.id;
      }

      if (!this.state.isValid) {
        extra.className += ' invalid';
      }

      if (this.state.value) {
        val = this.state.value;
      }

      var i = 0;
      var opts = this.props.options.map(function (opt) {
        i++;

        if (opt.title) {
          return /*#__PURE__*/_react.default.createElement("option", {
            key: "trc-input-opt-".concat(i).concat(opt.value),
            value: opt.value
          }, opt.title);
        } else {
          return /*#__PURE__*/_react.default.createElement("option", {
            key: "trc-input-opt-".concat(i).concat(opt),
            value: opt
          }, opt);
        }
      });
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("select", _extends({}, extra, {
        onChange: this.onChange,
        value: val
      }), opts), this.props.error && /*#__PURE__*/_react.default.createElement("span", {
        className: "error"
      }, this.props.error));
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var type = this.props.type ? this.props.type : 'text';
      var val = '';
      var extra = {
        className: 'trc-input'
      };

      if (this.props.id) {
        extra['id'] = this.props.id;
      }

      if (this.props.disabled) {
        extra['disabled'] = 'disabled';
      }

      if (this.props.inputId) {
        extra['id'] = this.props.inputId;
      }

      if (!this.state.isValid || this.props.error) {
        extra.className += ' invalid';
      }

      if (this.state.value) {
        val = this.state.value;
      }

      if (this.props.placeholder) {
        extra.placeholder = this.props.placeholder;
      }

      if (this.props.className) {
        extra.className += ' ' + this.props.className + ' ';
      }

      if (this.props.type === 'submit') {
        extra.className += ' trace-input';
      }

      if (this.props.autoFocus) {
        extra.ref = function (el) {
          return el && el.focus();
        };
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", _extends({}, extra, {
        type: type,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        value: val
      })), this.props.error && /*#__PURE__*/_react.default.createElement("span", {
        className: "error"
      }, this.props.error));
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {}
  }]);

  return TRCInput;
}(_react.Component);

exports.default = TRCInput;

var ValidateInteger = function ValidateInteger(val) {
  var regex = /^\d+?$/;
  var res = regex.test(val);

  if (res) {
    return null;
  }

  return 'Must be an integer.';
};

exports.ValidateInteger = ValidateInteger;

var ValidateBool = function ValidateBool(val) {
  if (val === 'True' || val === 'TRUE' || val === 'true' || val === '1') {
    return null;
  }

  if (val === 'False' || val === 'FALSE' || val === 'false' || val === '0') {
    return null;
  }

  return 'Must be a boolean value.';
};

exports.ValidateBool = ValidateBool;

var ValidateNumber = function ValidateNumber(val) {
  var regex = /^[\d\.]+?$/; // eslint-disable-line no-useless-escape

  var res = regex.test(val);

  if (res) {
    return null;
  }

  return 'Must be a number';
};

exports.ValidateNumber = ValidateNumber;

var ValidateNotEmpty = function ValidateNotEmpty(val) {
  if (val.length > 0) {
    return null;
  }

  return 'Value is requrited';
};

exports.ValidateNotEmpty = ValidateNotEmpty;

var ValidateLength = function ValidateLength(val, length) {
  if (val.length >= length) {
    return null;
  }

  return "Must be at least ".concat(length, " characters");
};

exports.ValidateLength = ValidateLength;